export default "__VITE_ASSET__Dx11h9iM__"